import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../../helpers/common';

export const ProfitAndLossNewLoadingKeys = {
    getBudgetForecastsData: "GET_BUDGET_FORECASTS_DATA",
    getCompareOptions: "GET_COMPARE_OPTIONS",
    getProfitAndLossSnapshotOptions: "GET_PROFIT_AND_LOSS_SNAPSHOT_OPTIONS",
    getProfitAndLossSnapshotData: "GET_PROFIT_AND_LOSS_SNAPSHOT_DATA",
    getBudgetForecastsOptions: "GET_BUDGET_FORECASTS_OPTIONS",
    getProfitAndLossNewData: "GET_PROFIT_AND_LOSS_NEW_DATA",
    getProfitAndLossTables: "GET_PROFIT_AND_LOSS_TABLES",
    createProfitAndLossTableItem: "CREATE_PROFIT_AND_LOSS_TABLE_ITEM",
    updateProfitAndLossTableItem: "UPDATE_PROFIT_AND_LOSS_TABLE_ITEM",
    deleteProfitAndLossTableItem: "DELETE_PROFIT_AND_LOSS_TABLE_ITEM",
    updateProfitAndLossTablePositions: "UPDATE_PROFIT_AND_LOSS_TABLE_POSITIONS",
    getProfitAndLossKeys: "GET_PROFIT_AND_LOSS_KEYS",
    getBudgetLineItemsForCalculation: "GET_BUDGET_LINE_ITEMS_FOR_CALCULATION",
}

const initialState = {
    compareOptions: [],
    snapshotOptions: [],
    budgetOptions: [],
    profitAndLossNewData: null,
    budgetAndForecastData: null,
    profitAndLossTables: {},
    profitAndLossKeys: [],
    budgetLineItemsForCalculation: [],
    loadingKeys: [],
    loading: false,
    error: null,
}

export const getBudgetForecastsData = createAsyncThunk(
  'profitAndLossNew/getBudgetForecastsData',
  async ({
      budgetId,
  }, { rejectWithValue }) => {
      try {
          const { data } = await axios.get('/api/v1/profit-and-loss-new/budget-and-forecast-data', { params: {
              budgetId,
          }});
          return data;
      } catch (error) {
          if ('string' === typeof error.response.data) {
              return rejectWithValue(error.response.data)
          } else {
              return rejectWithValue(error.response.data.errors || error.response.data.error)
          }
      }
  }
)

export const getBudgetForecastsOptions = createAsyncThunk(
  'profitAndLossNew/getBudgetForecastsOptions',
  async (_, { rejectWithValue }) => {
      try {
          const { data } = await axios.get('/api/v1/profit-and-loss-new/budget-and-forecast-options');
          return data;
      } catch (error) {
          if ('string' === typeof error.response.data) {
              return rejectWithValue(error.response.data)
          } else {
              return rejectWithValue(error.response.data.errors || error.response.data.error)
          }
      }
  }
)

export const getCompareOptions = createAsyncThunk(
  'profitAndLossNew/getCompareOptions',
  async ({}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/compare-options`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response.data.errors || error.response.data.error)
      }
    }
  }
)

export const getProfitAndLossSnapshotOptions = createAsyncThunk(
  'profitAndLossNew/getProfitAndLossSnapshotOptions',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/snapshots/options`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const getProfitAndLossSnapshotData = createAsyncThunk(
  'profitAndLossNew/getProfitAndLossSnapshotData',
  async ({
    snapshotDate,
    startDate,
    endDate,
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/snapshots/data`, {
        params: {
          snapshotDate,
          startDate,
          endDate,
        }
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const getProfitAndLossNewData = createAsyncThunk(
  'profitAndLossNew/getProfitAndLossNewData',
  async ({
    startDate,
    endDate,
    compareType,
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/data`, {
        params: {
          startDate,
          endDate,
          compareType,
        }
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response.data.errors || error.response.data.error)
      }
    }
  }
)

export const getProfitAndLossTables = createAsyncThunk(
  'profitAndLossNew/getProfitAndLossTables',
  async ({ table_key }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/tables`, {
        params: { table_key }
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const createProfitAndLossTableItem = createAsyncThunk(
  'profitAndLossNew/createProfitAndLossTableItem',
  async ({ table_key, item, position, calculation_profit_and_loss, calculation_budget }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`/api/v1/profit-and-loss-new/tables`, {
        table_key,
        item,
        position,
        calculation_profit_and_loss,
        calculation_budget,
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const updateProfitAndLossTableItem = createAsyncThunk(
  'profitAndLossNew/updateProfitAndLossTableItem',
  async ({ id, item, position, calculation_profit_and_loss, calculation_budget }, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(`/api/v1/profit-and-loss-new/tables/${id}`, {
        item,
        position,
        calculation_profit_and_loss,
        calculation_budget,
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const deleteProfitAndLossTableItem = createAsyncThunk(
  'profitAndLossNew/deleteProfitAndLossTableItem',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`/api/v1/profit-and-loss-new/tables/${id}`);
      return { id, data };
    } catch (error) {
      if (error.response?.status === 409) {
        return rejectWithValue(error.response.data || { error: 'Table item cannot be deleted' });
      }
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const updateProfitAndLossTablePositions = createAsyncThunk(
  'profitAndLossNew/updateProfitAndLossTablePositions',
  async ({ positionUpdates }, { rejectWithValue }) => {
    try {
      const { data } = await axios.patch(`/api/v1/profit-and-loss-new/tables/positions`, {
        positionUpdates
      });
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const getProfitAndLossKeys = createAsyncThunk(
  'profitAndLossNew/getProfitAndLossKeys',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/keys`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const getBudgetLineItemsForCalculation = createAsyncThunk(
  'profitAndLossNew/getBudgetLineItemsForCalculation',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/profit-and-loss-new/budget-line-items`);
      return data;
    } catch (error) {
      if ('string' === typeof error.response?.data) {
        return rejectWithValue(error.response.data)
      } else {
        return rejectWithValue(error.response?.data?.errors || error.response?.data?.error)
      }
    }
  }
)

export const profitAndLossNewSlice = createSlice({
  name: 'profitAndLossNew',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(getBudgetForecastsData.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getBudgetForecastsData];
        })
        .addCase(getBudgetForecastsData.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.budgetAndForecastData = action.payload;
            state.firstLoading = false;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getBudgetForecastsData, state.loadingKeys);
        })
        .addCase(getBudgetForecastsData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.budgetAndForecastData = null;
            state.firstLoading = false;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getBudgetForecastsData, state.loadingKeys);
        })
        .addCase(getBudgetForecastsOptions.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getBudgetForecastsOptions];
        })
        .addCase(getBudgetForecastsOptions.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.budgetOptions = action.payload.budgetOptions || [];
            state.firstLoading = false;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getBudgetForecastsOptions, state.loadingKeys);
        })
        .addCase(getBudgetForecastsOptions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.budgetOptions = [];
            state.firstLoading = false;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getBudgetForecastsOptions, state.loadingKeys);
        })
        .addCase(getCompareOptions.pending, (state) => {
            state.loading = true
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getCompareOptions]
        })
        .addCase(getCompareOptions.fulfilled, (state, action) => {
            state.loading = false;
            state.compareOptions = action.payload?.items || [];
            state.error = null;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getCompareOptions, state.loadingKeys)
        })
        .addCase(getCompareOptions.rejected, (state, action) => {
            state.loading = false;
            state.compareOptions = null;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getCompareOptions, state.loadingKeys)
        })
        .addCase(getProfitAndLossSnapshotOptions.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getProfitAndLossSnapshotOptions]
        })
        .addCase(getProfitAndLossSnapshotOptions.fulfilled, (state, action) => {
            state.loading = false;
            state.snapshotOptions = action.payload?.items || [];
            state.error = null;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossSnapshotOptions, state.loadingKeys)
        })
        .addCase(getProfitAndLossSnapshotOptions.rejected, (state, action) => {
            state.loading = false;
            state.snapshotOptions = [];
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossSnapshotOptions, state.loadingKeys)
        })
        .addCase(getProfitAndLossNewData.pending, (state) => {
            state.loading = true
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getProfitAndLossNewData]
        })
        .addCase(getProfitAndLossNewData.fulfilled, (state, action) => {
            state.loading = false
            state.profitAndLossNewData = action.payload;
            state.error = null;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossNewData, state.loadingKeys)
        })
        .addCase(getProfitAndLossNewData.rejected, (state, action) => {
            state.loading = false
            state.profitAndLossNewData = null;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossNewData, state.loadingKeys)
        })
        .addCase(getProfitAndLossSnapshotData.pending, (state) => {
            state.loading = true
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getProfitAndLossSnapshotData]
        })
        .addCase(getProfitAndLossSnapshotData.fulfilled, (state, action) => {
            state.loading = false
            state.profitAndLossNewData = action.payload;
            state.error = null;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossSnapshotData, state.loadingKeys)
        })
        .addCase(getProfitAndLossSnapshotData.rejected, (state, action) => {
            state.loading = false
            state.profitAndLossNewData = null;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossSnapshotData, state.loadingKeys)
        })
        .addCase(getProfitAndLossTables.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getProfitAndLossTables];
        })
        .addCase(getProfitAndLossTables.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            // Group tables by table_key
            const tablesByKey = {};
            (action.payload?.tables || []).forEach(table => {
                if (!tablesByKey[table.table_key]) {
                    tablesByKey[table.table_key] = [];
                }
                tablesByKey[table.table_key].push(table);
            });
            state.profitAndLossTables = { ...state.profitAndLossTables, ...tablesByKey };
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossTables, state.loadingKeys);
        })
        .addCase(getProfitAndLossTables.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossTables, state.loadingKeys);
        })
        .addCase(createProfitAndLossTableItem.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.createProfitAndLossTableItem];
        })
        .addCase(createProfitAndLossTableItem.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            const tableItem = action.payload?.tableItem;
            if (tableItem) {
                if (!state.profitAndLossTables[tableItem.table_key]) {
                    state.profitAndLossTables[tableItem.table_key] = [];
                }
                state.profitAndLossTables[tableItem.table_key].push(tableItem);
                // Sort by position
                state.profitAndLossTables[tableItem.table_key].sort((a, b) => a.position - b.position);
            }
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.createProfitAndLossTableItem, state.loadingKeys);
        })
        .addCase(createProfitAndLossTableItem.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.createProfitAndLossTableItem, state.loadingKeys);
        })
        .addCase(updateProfitAndLossTableItem.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.updateProfitAndLossTableItem];
        })
        .addCase(updateProfitAndLossTableItem.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            const tableItem = action.payload?.tableItem;
            if (tableItem) {
                const tableKey = tableItem.table_key;
                if (state.profitAndLossTables[tableKey]) {
                    const index = state.profitAndLossTables[tableKey].findIndex(t => t.id === tableItem.id);
                    if (index !== -1) {
                        state.profitAndLossTables[tableKey][index] = tableItem;
                        // Sort by position
                        state.profitAndLossTables[tableKey].sort((a, b) => a.position - b.position);
                    }
                }
            }
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.updateProfitAndLossTableItem, state.loadingKeys);
        })
        .addCase(updateProfitAndLossTableItem.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.updateProfitAndLossTableItem, state.loadingKeys);
        })
        .addCase(deleteProfitAndLossTableItem.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.deleteProfitAndLossTableItem];
        })
        .addCase(deleteProfitAndLossTableItem.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            const { id } = action.payload;
            // Remove from all table keys
            Object.keys(state.profitAndLossTables).forEach(tableKey => {
                state.profitAndLossTables[tableKey] = state.profitAndLossTables[tableKey].filter(t => t.id !== id);
            });
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.deleteProfitAndLossTableItem, state.loadingKeys);
        })
        .addCase(deleteProfitAndLossTableItem.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.deleteProfitAndLossTableItem, state.loadingKeys);
        })
        .addCase(updateProfitAndLossTablePositions.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.updateProfitAndLossTablePositions];
        })
        .addCase(updateProfitAndLossTablePositions.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            // Positions are updated in the backend, we should refetch or update locally
            // For now, we'll just mark as successful
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.updateProfitAndLossTablePositions, state.loadingKeys);
        })
        .addCase(updateProfitAndLossTablePositions.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.updateProfitAndLossTablePositions, state.loadingKeys);
        })
        .addCase(getProfitAndLossKeys.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getProfitAndLossKeys];
        })
        .addCase(getProfitAndLossKeys.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.profitAndLossKeys = action.payload?.keys || [];
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossKeys, state.loadingKeys);
        })
        .addCase(getProfitAndLossKeys.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getProfitAndLossKeys, state.loadingKeys);
        })
        .addCase(getBudgetLineItemsForCalculation.pending, (state) => {
            state.loading = true;
            state.loadingKeys = [...state.loadingKeys, ProfitAndLossNewLoadingKeys.getBudgetLineItemsForCalculation];
        })
        .addCase(getBudgetLineItemsForCalculation.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.budgetLineItemsForCalculation = action.payload?.items || [];
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getBudgetLineItemsForCalculation, state.loadingKeys);
        })
        .addCase(getBudgetLineItemsForCalculation.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error?.message;
            state.loadingKeys = removeLoadingKey(ProfitAndLossNewLoadingKeys.getBudgetLineItemsForCalculation, state.loadingKeys);
        })
  }
})

export const {} = profitAndLossNewSlice.actions;

export default profitAndLossNewSlice.reducer;
